// src/Component/TrustedSection.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import img from '../assets/tradeimg.webp'; // आपकी ओरिजिनल इमेज

const TrustedSection: React.FC = () => {
  return (
    <section className="relative py-16 md:py-24 bg-white overflow-hidden font-[Urbanist]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        
        {/* =========================================
            1. CENTERED HEADING (Premium Orange-Gold)
            ========================================= */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-red-700 uppercase tracking-wide">
            MOTILAL ALGO - YOUR TRUSTED ALGO TRADING PLATFORM
          </h2>
        </motion.div>

        {/* =========================================
            2. TWO COLUMN LAYOUT (Refined)
            ========================================= */}
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          
          {/* LEFT COLUMN: Text Content & Buttons */}
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="w-full lg:w-1/2 flex flex-col space-y-6 md:space-y-8"
          >
            <p className="text-gray-700 leading-relaxed text-base md:text-lg lg:text-xl text-justify md:text-left font-medium">
              Welcome to MOTILAL ALGO, your trusted partner for <strong className="text-black font-extrabold underline decoration-[#f59e0b]">Algo Trading services</strong>. As financial markets worldwide move toward automation and digitization, the importance of algorithmic execution in today's market cannot be overstated. 
            </p>
            
            <p className="text-gray-700 leading-relaxed text-base md:text-lg lg:text-xl text-justify md:text-left font-medium">
              A <strong className="text-black font-extrabold border-b-2 border-gray-300">professional trading platform</strong> creates a result-driven environment for investors to capture more market opportunities and increase consistency. At MOTILAL ALGO, we understand the importance of speed and reliability.
            </p>

            <p className="text-gray-700 leading-relaxed text-base md:text-lg lg:text-xl text-justify md:text-left font-medium">
              We have built hundreds of successful strategies and robust trading setups, and know what it takes to build an algo environment that generates consistent execution and minimizes manual errors.
            </p>

            {/* ACTION BUTTONS (Solid Dark Style) */}
            <div className="flex flex-col sm:flex-row gap-5 pt-4">
              <Link to="/demat/register" className="w-full sm:w-auto">
                <button className="w-full sm:w-auto bg-[#1a1c20] hover:bg-black text-white text-base font-extrabold py-4 px-10 rounded shadow-xl transition-all active:scale-95 uppercase">
                  OPEN DEMAT ACCOUNT
                </button>
              </Link>
              <Link to="/features" className="w-full sm:w-auto">
                <button className="w-full sm:w-auto bg-[#1a1c20] hover:bg-black text-white text-base font-extrabold py-4 px-10 rounded shadow-xl transition-all active:scale-95 uppercase">
                  VIEW OUR FEATURES
                </button>
              </Link>
            </div>
          </motion.div>

          {/* RIGHT COLUMN: Image/Vector */}
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="w-full lg:w-1/2 flex justify-center mt-10 lg:mt-0"
          >
            <div className="relative group">
              {/* Subtle Shadow behind image for depth */}
              <div className="absolute inset-0 bg-blue-100 rounded-2xl blur-3xl opacity-20 -z-10 group-hover:opacity-40 transition-opacity"></div>
              <img 
                src={img} 
                alt="Motilal Algo Trading Dashboard" 
                className="w-full max-w-xl object-contain drop-shadow-2xl rounded-2xl transition-transform duration-500 group-hover:scale-105"
              />
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default TrustedSection;